import React from "react";
import Store from "../ExpirationSettingsStore";
import Actions from "../ExpirationsActions";
import { links } from "../../routes";
import { IExpirationSettingsDto, ExpirationSingleSettings } from "../../generated";
import SingleSettingsEditor from "./ExpirationsSettingsEditor";
import { RouteComponentProps } from "react-router-dom";
import { Loading } from "../../common/components/loading";
import Button from "../../common/components/button";
import { CheckBox } from "../../common/components/checkBox2";
import { Divider } from "../../common/components/CmForms";

interface Props extends RouteComponentProps {

}


export default ({ history }: Props) => {
    const [value, onChange] = Store.useSettings();

    const save = async (data: IExpirationSettingsDto) => {
        Actions.save(data);
        history.replace(links.expirationsSettings)
    }
    if (!value || !onChange)
        return <Loading />

    return <div className="card">
        <div className="card-header bg-theme d-flex align-items-center">
            <div className="flex-fill">
                <h3 className="text-white mb-0">Configurazione Scadenze</h3>
            </div>
        </div>

        <div className="card-body">
            <form>

                <div className="row">
                    <div className="col-12 col-md-6">
                        <SingleSettingsEditor
                            caption="Manutenzione ordinaria"
                            settings={value.standard ?? new ExpirationSingleSettings({ beginAfterMonths: 12, defaultMonths: 12, rules: [], disabled: false })}
                            onChange={standard => onChange({ ...value, standard: new ExpirationSingleSettings(standard) })}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <SingleSettingsEditor
                            caption="Controllo combustione caldaie <35Kw"
                            settings={value.combustioneU35 ?? new ExpirationSingleSettings({ beginAfterMonths: 12, defaultMonths: 12, rules: [], disabled: false })}
                            onChange={combustioneU35 => onChange({ ...value, combustioneU35: new ExpirationSingleSettings(combustioneU35) })}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <SingleSettingsEditor
                            caption="Controllo combustione caldaie >35Kw"
                            settings={value.combustioneO35 ?? new ExpirationSingleSettings({ beginAfterMonths: 12, defaultMonths: 12, rules: [], disabled: false })}
                            onChange={combustioneO35 => onChange({ ...value, combustioneO35: new ExpirationSingleSettings(combustioneO35) })}
                        />
                    </div>
                </div>
                <div className="row py-3 mb-3">
                    <div className="col-12 col-md-6">
                        <Divider caption="Scadenze contratti" />
                        <CheckBox
                            label="Attiva\Disattiva"
                            checked={value.contratti}
                            onChange={checked => onChange({ ...value, contratti: checked })}
                        />
                    </div>
                    {/* <div className="col-12 col-md-6">
                        <SingleSettingsEditor
                            caption="Bollini"
                            settings={value.bollini ?? new ExpirationSingleSettings({ beginAfterMonths: 12, defaultMonths: 12, rules: [], disabled: false })}
                            onChange={bollini => onChange({ ...value, bollini: new ExpirationSingleSettings(bollini) })}
                        />
                    </div> */}
                </div>
                <Button color="primary" onClick={() => save(value)}><i className="fa fa-check" /> Salva</Button>{" "}
                <Button
                    type="button"
                    color="inverse"
                    onClick={() => history.goBack()}
                >
                    <i className="fas fa-undo" /> Esci
                </Button>
            </form>
        </div>
    </div>

}